export default __webpack_public_path__ + "static/athena-9cdfcf2c528e11e25c84b9dd3055e0db.png";